import { Card } from "@radix-ui/themes";
import { SessionTab, SessionTabs } from "components/session";
import { BackNavigation } from "components/shared";
import { AppPage } from "layouts/types";
import { ISession, IProgram } from "models";
import moment from "moment";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { RootState, AppDispatch } from "store";
import { getProgramDetail, resetCurrentProgram } from "store/reducers/programs";

const transformTabsData = (sessions: ISession[]) => {
  const tabs = sessions.reduce((acc: any, session: ISession) => {
    acc[session.name] = [
      { id: session.id, TabContent: <SessionTab session={session} /> },
    ];
    return acc;
  }, {});
  return tabs;
};

const ProgramDetailCard = ({ program }: { program: IProgram }) => {
  return (
    <>
      <div className="flex w-full">
        <BackNavigation title={program.name} />
      </div>
      <div className="my-8 gap-4 text-zinc-600 text-center">
        <div className="flex justify-center">
          <div className="grid grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-3 desktop:grid-cols-3 largescreen:grid-cols-3 w-3/4 mobile:w-full gap-4">

            {/* Overall Program Duration */}
            <div className="flex flex-col m-2 tablet:p-1">
              <Card className="flex-1 h-full">
                <div className="flex flex-col items-center justify-center text-center p-4 h-full">
                  <div className="text-sm">Overall Program Duration</div>
                  <div className="font-bold">
                    {moment(program?.startDate).format("DD MMM YYYY")} -{" "}
                    {moment(program?.endDate).format("DD MMM YYYY")}
                  </div>
                </div>
              </Card>
            </div>

            {/* No. of Sessions */}
            <div className="flex flex-col m-2 tablet:p-1">
              <Card className="flex-1 h-full">
                <div className="flex flex-col items-center justify-center text-center p-4 h-full">
                  <div className="text-sm">No. of Sessions</div>
                  <div className="font-bold">
                    {program?.sessions?.length}{" "}
                    {program?.sessions?.length! > 1 ? "Sessions" : "Session"}
                  </div>
                </div>
              </Card>
            </div>

            {/* Batch Name */}
            <div className="flex flex-col m-2 tablet:p-1">
              <Card className="flex-1 h-full">
                <div className="flex flex-col items-center justify-center text-center p-4 h-full">
                  <div className="text-sm">Batch Name</div>
                  <div className="font-bold">{program?.batchName}</div>
                </div>
              </Card>
            </div>

          </div>
        </div>
      </div>

    </>
  );
};

const ProgramDetail: AppPage = () => {
  const router = useNavigate();
  const { programId } = useParams<{ programId: string }>();
  const { currentProgram } = useSelector((state: RootState) => state.programs);
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {

    if (!programId) return;

    dispatch(getProgramDetail({ id: programId as string }))

    return () => { dispatch(resetCurrentProgram()) }


  }, [programId]);

  if (!currentProgram)
    return (
      <>
        <BackNavigation title="Program Detail"></BackNavigation>
        <div className="w-screen h-screen flex justify-center items-center">
          {" "}
          Please wait while program details are loading .....{" "}
        </div>
      </>
    );

  return (
    <div className="">
      <ProgramDetailCard program={currentProgram} />
      {currentProgram.sessions && (
        <SessionTabs
          sessions={currentProgram.sessions ? transformTabsData(currentProgram.sessions) : []}
        />
      )}
    </div>
  );
};

export default ProgramDetail;